import { jsx } from "react/jsx-runtime";
import { Link } from "@nxt-costco-com/forge-components";
import { COMPONENT_NAME } from "../constants.js";
const ConditionalLink = ({
  children,
  href,
  uniqueId
}) => {
  return href ? /* @__PURE__ */ jsx(Link, { href, uniqueId: `${COMPONENT_NAME}_${uniqueId}`, children }) : children;
};
export {
  ConditionalLink
};
